$('.js-accordionToggle').on('click', (e) => {
  const currentTarget = $(e.currentTarget)
  const parent = currentTarget.parent()
  const content = parent.find('.accordion-content')

  currentTarget.toggleClass('accordion-header_is_opened')
  content.slideToggle(400)
})
